import {ContractorCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'UPDATE_CONTRACTOR_CATEGORY';

export async function updateContractorCategory(userData: any, contractorCategoryId: number | string, payload: Record<string, unknown>) {
    try {
        const result = await ContractorCategoryDao.updateContractorCategory(userData, contractorCategoryId, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour de la catégorie sous/co-traitant',
            error: error
        });
    }
}
